import { useMemo } from 'react'

/**
 * Hook to calculate the effective platform based on meeting metadata
 *
 * @param source - The meeting source (e.g., 'voice-memo')
 * @param platform - The platform from metadata
 * @param userAgent - The user agent from metadata
 * @returns The effective platform string ('desktop', 'mobile', or original platform)
 */
export const useEffectivePlatform = (
  source: string | null | undefined,
  platform: string | null | undefined,
  userAgent: string | null | undefined,
): string | null | undefined => {
  return useMemo(() => {
    if (source === 'voice-memo') {
      if (platform) {
        return 'desktop'
      } else if (userAgent) {
        return 'mobile'
      }
    }
    return platform
  }, [source, platform, userAgent])
}
